import { BookFoodSummaryModel, BookOrderFoodModel } from '@/model/bookOrderFood';

export const isCancelledBookFood = (row: BookOrderFoodModel): boolean =>
  row.orderStatus === 999 || row.foodStatus === 999;

export const bookFoodOrderKey = (row: BookOrderFoodModel): string =>
  JSON.stringify([row.companyName, row.shopName, row.orderNo]);

export const bookFoodDate = (row: BookOrderFoodModel): string =>
  row.selfPickDate?.slice(0, 10) || '未填写日期';

export const aggregateBookOrderFood = (rows: BookOrderFoodModel[]): BookFoodSummaryModel[] => {
  const groups = new Map<string, BookFoodSummaryModel>();
  const orders = new Map<string, Set<string>>();
  for (const row of rows) {
    const date = bookFoodDate(row);
    // 接口未返回菜品 ID，按预定日期、餐厅、分类和菜名合并不同规格。
    const key = JSON.stringify([
      date,
      row.companyName,
      row.shopName,
      row.categoryName,
      row.shopFoodName,
    ]);
    const group = groups.get(key) || {
      key,
      date,
      shopName: row.shopName || '未填写餐厅',
      categoryName: row.categoryName || '未分类',
      shopFoodName: row.shopFoodName || '未填写菜品',
      quantity: 0,
      cancelledQuantity: 0,
      amount: 0,
      orderCount: 0,
    };
    const quantity = Number(row.quantity) || 0;
    if (isCancelledBookFood(row)) {
      group.cancelledQuantity += quantity;
    } else {
      group.quantity += quantity;
      group.amount += Number(row.amount) || 0;
      const orderSet = orders.get(key) || new Set<string>();
      if (row.orderNo) orderSet.add(bookFoodOrderKey(row));
      orders.set(key, orderSet);
      group.orderCount = orderSet.size;
    }
    groups.set(key, group);
  }
  return [...groups.values()]
    .map((group) => ({
      ...group,
      quantity: Number(group.quantity.toFixed(6)),
      cancelledQuantity: Number(group.cancelledQuantity.toFixed(6)),
      amount: Number(group.amount.toFixed(2)),
    }))
    .sort(
      (a, b) =>
        a.date.localeCompare(b.date) ||
        a.shopName.localeCompare(b.shopName, 'zh-CN') ||
        a.categoryName.localeCompare(b.categoryName, 'zh-CN') ||
        a.shopFoodName.localeCompare(b.shopFoodName, 'zh-CN'),
    );
};
